import React, { useState } from "react";
import "./DraggableTable.css";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '../../assets/svg/closeIconofmodal.svg';
import CustomModal from '../../ReUsableComponent/CustomModal';

const viewReportFileModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#F2F2F2',
    boxShadow: 24,
    p: '40px 32px',
    borderRadius: 6,
    border: '1px solid #3333330D'
};

const DraggableTable = ({ rows = [] }) => {

    const [viewAllInfo, setViewAllInfo] = useState(false);
    const [selectedDescription, setSelectedDescription] = useState("");

    // ------------------------------
    // Show Description Modal
    // ------------------------------
    const onClickInfo = (description) => {
        setSelectedDescription(description || "No Description");
        setViewAllInfo(true);
    };

    // Filter rows to show only those with status: true
    const visibleRows = rows.filter(row => row.status);

    return (
        <div>
            <table className="dt-table">
                <thead>
                    <tr>
                        <th>Header Name</th>
                        <th>Header Label</th>
                        <th>Color</th>
                        <th>Description</th>
                    </tr>
                </thead>

                <tbody>
                    {visibleRows.map((row) => (
                        <tr key={row.id}>
                            <td>{row.name}</td>
                            <td>{row.header_label}</td>

                            <td>
                                <div
                                    style={{
                                        width: "24px",
                                        height: "24px",
                                        backgroundColor: row.color,
                                        borderRadius: "4px",
                                        border: "1px solid #ddd"
                                    }}
                                ></div>
                            </td>

                            <td>
                                <button onClick={() => onClickInfo(row.abbreviation)}>
                                    <InfoOutlinedIcon fontSize='small' style={{ marginLeft: "10px" }} />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Description Modal */}
            <CustomModal
                classes="customeProgressModal"
                open={viewAllInfo}
                handleClose={() => setViewAllInfo(false)}
                style={viewReportFileModalStyle}
                content={
                    <div>
                        <div className='d-flex align-items-center'>
                            <button
                                className='uploadFileModalCloseIcon cursorPointer'
                                onClick={() => setViewAllInfo(false)}
                            >
                                <img src={CloseIcon} alt="" />
                            </button>
                        </div>

                        <div className='custom-height custom-report'>
                            <div>{selectedDescription}</div>
                        </div>
                    </div>
                }
            />
        </div>
    );
};

export default DraggableTable;
